import { render } from "./right_manage.vue?vue&type=template&id=175c9171&scoped=true"
import script from "./right_manage.vue?vue&type=script&lang=js"
export * from "./right_manage.vue?vue&type=script&lang=js"

import "./right_manage.vue?vue&type=style&index=0&id=175c9171&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175c9171"]])

export default __exports__